<template>
  <div class="qrcode">
    <section :class="{content: true, contentX: isX}">
      
      <div class="content-top">
        <div class="content-title">
          <template v-if="signUpResultType == 1">
            <h2>长按入群</h2>
            <p>入群获取<span>课程配套资料</span>和<span>提分秘籍</span></p>
          </template>
          <template v-else>
            <h2>长按锁定座位</h2>
            <p>找助教领<span>提分资料</span></p>
          </template>
        </div>
        <img :src="qrCodeimgUrl" class="loadImg" @load="imgLoad()" @touchstart="touchStart" @touchmove="touchmove" @touchend="touchend" />
        <!-- <img class="loadImg" @load="imgLoad()" src="https://devtest1020.oss-cn-shanghai.aliyuncs.com/3dbfc96d6d0f4976a4bc0b17af003f86"/> -->
      </div>
      <div class="tipsBox">
        
        <div class="content-tips">
          <p>无法长按识别二维码？</p>
          <p>1.截屏或长按保存图片到手机相册。</p>

          <p v-if="signUpResultType == 1">2.打开微信识别二维码，扫码入群。</p>
          <p v-else>2.打开微信识别二维码，点击添加。</p>
        </div>
      </div>
      
    </section>
  </div>
  
</template>

<script>
// @ is an alias to /src

export default {
  name: "qrCode",
  components: {
    'remote-js': {
        render(createElement) {
              return createElement('script', { attrs: { type: 'text/javascript', src: this.src }});
        },
        props: {
            src: { type: String, required: true },
        },
    },
  },
  data() {
    return {
      QRurl: '',
      isX: false,
      isLoad: false,
      wechatInfo: '',
      dianParams: '',
      weChatID: '',
      sourceCode: '',
      termId: null,
      qrCodeimgUrl:"",
      requestParam:{
        marketingId:null,
        groupId:null,
        unionId:null,
        ppid:null,
        operation:2
      },
      ip:"",
      resParams:{
          url:"",//|是|当前url
          appVersion:"",//|否|app版本
          sourceId:"",//|否|活动/公开课id
          sourceChannel:"",//|否|活动/公开课标志
          title:"",//|否|活动/公开课名称
          operation:"",//|否|点位标志
          unionId:"",//|否|unionId
          openid:"",//|否|openid
          ppid:"",//|是|ppid
          groupId:"",//|否|群码id
          groupName:"",//|否|群码名称
          assistantId:"",//|否|助教/运营id
          assistantName:"",//|否|助教名称
          channelCode:"",//|否|渠道号
          trigger_event:"",//|是|事件区分：报名进入/入群学习进入
          weChatId:"",
          operation:1
     },
     signUpResultType:1 //信息类型|1=群码，2=助教，3=运营
    };
    
  },
  methods:{
    dadian(operationid) {
      this.dianParams = {
        ppid: '',
        actCode: '',
        activityId: '',
        activityTitle: '',
        appVersion: '',
        ip: this.ip,
        mark: '',
        openid: this.wechatInfo.openid||'',
        operation: '',
        operationid: operationid,
        sourceCode: this.sourceCode,
        timeStamp: '',
        unionid: this.wechatInfo.unionid||''
      }
    },
    touchStart() {
      this.termId = setTimeout(() => {
        //this.dadian("B91")
        this.maidian(2);
      },1000);
    },
    touchmove() {
      clearTimeout(this.termId);
    },
    touchend() {
      clearTimeout(this.termId);
    },
    maidian(type){
      this.resParams.operation = type;
      this.$http.post(this.$baseUrl + 'mkt/qrcodePoint', this.resParams).then((res)=>{
          //this.$router.push(this.path);
        console.log('埋点成功');
      }).catch(() => {
        //this.$toast('埋点失败');
        console.log('埋点失败');
      })
    },
    getAssistantByUnionID() {
      let params = {
        unionID: this.wechatInfo.unionid
      }
      getAssistantByUnionID(params)
      .then((res) => {
        if (res.status == "OK") {
          if(res.message && res.message.WeChatQRCode) {
            this.QRurl = wechatCodeURL + res.message.WeChatQRCode
          } else {
            this.wxCheckPpid()
          }
        } else {
          this.wxCheckPpid()
        }
      })
      .catch((err) => {
        console.log(err)
      })
    },
    wxCheckPpid() {
      let params = {
        unionID: this.wechatInfo.unionid
      }
      wxCheckPpid(params).then(data => {
        if(data.status == "OK"){
          if (data.message == "0" || data.message == null) {
            this.isRegister = true;
          } else {
            this.getAsistentInfo(data.message);
          }
        } else {
          this.isRegister = true;
        }
      })
    },
    closeDialog(hideType, showType) {
      switch (hideType) {
        case "shortcutRegister":
          this.isRegister = false;
          break;
        case "wxApplyError":
          this.isWxApply = false;
          break;
        default:
      }
      this.showDialog(showType);
    },
    showDialog(type) {
      switch (type) {
        case "shortcutRegister":
          this.isRegister = true;
          break;
        case "wxApplyError":
          this.isWxApply = true;
          break;
        default:
      }
    },
    getAsistentInfo(ppid) {
      let params = {
        userId: ppid,
        sourceType: 1,
        sourceCode: '新的sourceCode,待替换'
      };
      unifiedQrCodeApi(params).then(data => {
        if (data.message && data.message.qrCode) {
          if (data.message.userType == 0) {
            location.href = data.message.qrCode
          } else {
            this.QRurl = wechatCodeURL + data.message.qrCode
          }
        }
      })
    },
    signUpZhanApi(uid, weChatInfo) {
      let params = {
        ppid: uid,
        sourceCode: source_code
      }
      // let params = {
      //   userId: uid,
      //   sourceCode: "LY2019012911",//线上 LY201611150105
      //   categoryId: "3",
      //   activityTitle: "小程序战团",
      //   signUpTime: new Date().Format('yyyy-MM-dd hh:mm:ss')
      // }
      assistentInfoPollApi(params).then(data => {
        if (data.status == "OK") {
          if(data.message) {
            this.QRurl = wechatCodeURL + data.message.WeChatQRCode;
          }
        }
      })
    },
    imgLoad() {
      this.isLoad = true
      this.dadian("B90")
    },
    matchIphoneX () {
      if (/iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375)) {
        this.isX = true
      } else {
        this.isX = false
      }
    },
    isNull(str){
      return str ? str : null;
    },
    isNullToInt(str){
      return str ? parseInt(str) : null;
    }
  },
  mounted() {
    this.matchIphoneX();
    //marketingId=1&groupId=1&unionId=abcde123&ppid=11144488824&imgUrl
    //http%3A%2F%2Fdevtest1020.oss-cn-shanghai.aliyuncs.com%2Fed266ed0eff24e9cb8f3f15eea217667
    //判断活码类型
    this.signUpResultType = this.isNullToInt(this.$route.query.signUpResultType);

    this.qrCodeimgUrl = this.isNull(decodeURIComponent(this.$route.query.imgUrl));
    
    this.requestParam.marketingId = this.isNullToInt(this.$route.query.marketingId);
    this.requestParam.groupId = this.isNullToInt(this.$route.query.groupId);
    this.requestParam.unionId = this.isNull(this.$route.query.unionId);
    this.requestParam.ppid = this.isNull(this.$route.query.ppid);

    //this.resParams.url=this.isNull(this.$route.fullPath);    
    this.resParams.url = window.location.href;
    this.resParams.appVersion=this.isNull(this.$route.query.appVersion);
    this.resParams.sourceId=this.isNull(this.$route.query.sourceId);
    this.resParams.sourceChannel=this.isNull(this.$route.query.sourceChannel);
    this.resParams.title=this.isNull(this.$route.query.title);
    //this.resParams.operation=this.isNull(this.$route.query.operation);
    this.resParams.unionId=this.isNull(this.$route.query.unionId);
    this.resParams.openid=this.isNull(this.$route.query.openid);
    this.resParams.ppid=this.isNull(this.$route.query.ppid);
    this.resParams.groupId=this.isNull(this.$route.query.groupId);
    this.resParams.groupName=this.isNull(this.$route.query.groupName);
    this.resParams.assistantId=this.isNull(this.$route.query.assistantId);
    this.resParams.assistantName=this.isNull(this.$route.query.assistantName);
    this.resParams.channelCode=this.isNull(this.$route.query.channelCode);
    this.resParams.trigger_event=this.isNull(this.$route.query.trigger_event);
    this.resParams.weChatId = this.isNull(this.$route.query.weChatId);
    
    // console.log(this.$route);
     
    this.maidian(1)
  },
  
};
</script>
<style lang="scss" scoped>
/*.font-size(@fontSize) {
  [data-dpr="1"] & {
    font-size: @fontSize;
  }
  [data-dpr="2"] & {
    font-size: @fontSize*2;
  }
  [data-dpr="3"] & {
    font-size: @fontSize*3;
  }
}
.width(@width) {
   [data-dpr="1"] & {
    max-width: @width;
    margin: 0 auto;
  }
}
.line-height(@lineHeight) {
  [data-dpr="1"] & {
    line-height: @lineHeight;
  }
  [data-dpr="2"] & {
    line-height: @lineHeight*2;
  }
  [data-dpr="3"] & {
    line-height: @lineHeight*3;
  }  
}*/
body{
  background: #EDEDED;
  height: 100vh;
  overflow: hidden;
  
}
.qrcode {
  position: relative;
  width:100%;
  height: 100vh;
  background: #EDEDED;
  overflow-y: auto;
  border-top: #ccc solid 1px;
}

.content {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100vh;
  margin-top: 50px; 
  display: flex;
  flex-direction: column;
  align-items: center;
  .content-top {
    height: auto;
  }
  .content-bg {
    width: 100%;
    height: auto;
  }
  .content-center {
    width: 600px;
    height: auto;
  }
  .loadImg {
    width: 600px;
    height: auto;
    /*border: 2px solid #fff;*/
    padding: 64px 0;
    margin-top: 40px;
  }
  .content-title{
    h2{
      font-size: 48px;
      line-height: 48px;
      color: #333333;
    }
    p{
      font-size: 30px;
      color: #666666;
      margin-top: 10px;
      span{
        font-weight: bold;
      }
    }
  }
  .tipsBox{
    margin-top: 50px;
    font-family: PingFangSC-Regular;  
  }
  .content-tips {
    padding-bottom:15px;
    font-size: 24px;
    color: #666666;
    letter-spacing: -0.01px;
    text-align: center;
    line-height: 38px;
    
  }
}
.contentX {
  padding-top: 10px;
}

</style>
